import React, { useEffect, useState } from "react";
import checkIfImageExists from "../../utils/checkIfImageExists";

const CustomizeDishImage = ({ productsSupabase, data }) => {
  const defaultImage = `/assets/${process.env.REACT_APP_MODE}/logo/logo2.png`;

  const [imageUrl, setImageUrl] = useState(defaultImage);

  const findProduct = productsSupabase?.find(
    (record) => record?.name === data?.item_name
  );

  const originalImageUrl = findProduct?.image_url;

  useEffect(() => {
    checkIfImageExists(originalImageUrl, (exists) => {
      if (exists) {
        setImageUrl(originalImageUrl);
      } else {
        setImageUrl(defaultImage);
      }
    });
  }, [originalImageUrl]);

  return imageUrl && <img src={imageUrl} alt="" className="customize-img" />;
};

export default CustomizeDishImage;
